var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    className: "chevron-up"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2F3641",
    fillRule: "evenodd",
    points: "8 15.707 6.293 14 12 8.293 17.707 14 16 15.707 12 11.707"
  })));
};
export default SvgChevronUp;